<template>
  <el-container class="container">
    <el-aside width="180px">
      <div class="logo logo__content">
        <img
          class="img"
          src="~index/assets/images/logo.png"
          alt
        />
      </div>
      <el-scrollbar class="scroll-menu">
        <side-menu></side-menu>
        <el-button
          type="text"
          class="supports link-info"
          @click="supportVisible = true"
        >技术支持</el-button>
      </el-scrollbar>
    </el-aside>
    <el-container style="height:100%">
      <el-header class="header">
        <top-nav>
          <div
            slot="header"
            class="clearfix"
          >
            <div class="project-tab">
              <a
                href="/#/xunjian"
                v-if="isXunjian"
                class="project-tab-item is-active"
              >区域走访工具</a>
              <a
                href="/"
                v-else
                class="project-tab-item is-active"
              >门店健康度</a>
            </div>
            <div style="float: right;margin-right: 30px;line-height: 66px;font-size: 12px;">
              <router-link
                to="/"
                class="link-primary"
              >
                <span class="icon-switch"></span>[切换项目]
              </router-link>
            </div>
          </div>
        </top-nav>
      </el-header>
      <VisitedTags v-show="!hideTag" />
      <el-main class="layout-main">
        <el-scrollbar
          id="mainScroll"
          style="height: 100%"
        >
          <div
            class="main_bg"
            id="container"
          >
            <div class="pt20 pb20 bg-white">
              <router-view />
            </div>
          </div>
        </el-scrollbar>
      </el-main>
    </el-container>
    <el-dialog
      :visible.sync="supportVisible"
      append-to-body
      :modal="false"
      width="300px"
    >
      <div class="title">技术支持</div>
      <el-form>
        <el-form-item label="邮箱：">lilin@personfg.com</el-form-item>
        <el-form-item label="电话：">010-84505518（9:00~18:00）</el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import TopNav from './TopNav'
import SideMenu from './SideMenu'
import VisitedTags from './VisitedTags'
export default {
  name: 'Layout',

  components: {
    TopNav,
    SideMenu,
    VisitedTags
  },

  computed: {
    hideTag () {
      return this.$route.meta.hideTag
    },
    isXunjian () {
      return /\/xunjian/.test(this.$route.path)
    }
  },

  data () {
    return {
      supportVisible: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .scroll-menu {
    padding-bottom: 40px;
    height: 100%;
  }
  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .el-header,
  .el-footer {
    margin: 0;
    padding: 0;
    background-color: #fff;
    color: #333;
  }
  .el-aside {
    position: relative;
    padding-top: 68px;
    background-color: #fff;
    color: #333;
  }
  .layout-main {
    background-color: #ecf0f5;
    color: #333;
    padding: 7px 20px;
    position: absolute;
    right: 0px;
    left: 180px;
    top: 90px;
    bottom: 0;
    .main_bg {
      padding-bottom: 20px;
      overflow: hidden;
    }
  }
  .container {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  .nav {
    margin-left: 20px;
    .actives {
      border-bottom: 4px solid #667184;
    }
    li {
      display: inline-block;
      padding: 0 15px;
      height: 52px;
      color: #667184;
      font-size: 16px;
      line-height: 52px;
      cursor: pointe;
    }
  }
  .logo__content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 68px;
    line-height: 68px;
    text-align: left;
    font-weight: bold;
    background: #fff;
    @include clearfix;
    & > div {
      float: left;
    }
    .img {
      width: 98px;
      height: 32.5px;
      margin: 16px 0 0 41px;
      line-height: 32px;
      text-align: center;
      font-size: 32px;
      font-weight: normal;
    }
    .title {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      margin: 13px 0 0 10px;
      & > span {
        display: block;
        height: 42px;
        line-height: 42px;
      }
    }
  }
  .logo {
    width: 180px;
  }
  .breadcrumb-container {
    margin-bottom: 20px;
  }
  .link-primary {
    .icon-switch {
      display: inline-block;
      margin-right: 6px;
      margin-top: -4px;
      width: 15px;
      line-height: 6px;
      vertical-align: middle;
      &::before,
      &::after {
        content: '';
        display: inline-block;
        width: 14px;
        height: 4px;
        border-width: 0 1px 1px 0;
        border-style: solid solid;
        border-color: #6d83bc;
        transform: skewX(30deg);
        transform-origin: center center;
      }
      &::after {
        transform: rotate(180deg) skewX(30deg);
        margin-left: 2px;
      }
    }
    &:hover .icon-switch::before,
    &:hover .icon-switch::after {
      border-color: mix($--color-primary, $--color-white, 80%);
    }
  }
  .project-tab {
    float: left;
    font-size: 16px;
    line-height: 68px;
  }
  .project-tab-item {
    position: relative;
    display: inline-block;
    margin-left: 24px;
    padding: 9px 6px 13px;
    color: #667184;
    line-height: 1;
    &.is-active {
      color: #6d83bc;
      &:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        height: 4px;
        border-radius: 2px;
        background-color: #6d83bc;
      }
    }
  }
  .supports {
    position: absolute;
    left: 35px;
    bottom: 5px;
    font-size: 14px;
  }
</style>
